/**
 * ProtectedRoute
 *
 * Wraps a route element and redirects to /login if the user
 * does not meet the minimum role requirement.
 */
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { hasRole, ROLES } from '@/lib/constants';

export function ProtectedRoute({ children, requiredRole = ROLES.CONTRIBUTOR }) {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-impact-dark">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-brand-500 border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated || !hasRole(user?.role, requiredRole)) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
